import fetch from '@/config/fetch';
import fetchNew from '@/config/fetchNew';

export const
  // 航次修改
  DevOpsVoyage = data => fetch('/platform/maintain/openVoyage', data, 'POST'),
  closeVoyage = data => fetchNew('/maintain/closeVoyage', data, 'POST'),
  // 上传手持机安装包
  uploadPackage = data => fetch('/platform/handset/infoRecord', data, 'POST'),
  // 下载手持机安装包
  downloadPackage = data => fetch('/platform/handset/apkDownload', data, 'POST'),
  // 长安民生运输管理-列表
  transportList = data => fetch('/platform/inter/transportChild/logPageList', data, 'GET'),
  // 月度考核维护-分配供应商/品牌-获取用户下拉数据
  getUser = data => fetch('/platform/essEmployee/selectList', data, 'GET'),
  // 月度考核维护-分配供应商-获取用户下拉数据
  getSuppliers = data => fetch('/platform/supplierMonthExamineManage/querySupplierList', data, 'GET'),
  // 月度考核维护-分配供应商-根据用户id获取供应商
  getSuppliersById = id => fetch(`/platform/supplierMonthExamineManage/queryUserSupplierList/${id}`, {}, 'GET'),
  // 月度考核维护-分配供应商-获取下拉数据
  submitSuppliers = data => fetch('/platform/supplierMonthExamineManage/addOrUpdateSupplierExamineConfig', data, 'POST'),
  // 月度考核维护-分配品牌-获取品牌下拉数据
  getBrandList = data => fetch('/platform/supplierMonthExamineManage/queryUndistributedBrand', data, 'GET'),
  // 月度考核维护-分配品牌-获取供应商下拉数据
  getSupplierList = data => fetch('/platform/supplierMonthExamineManage/querySupplierList', data, 'GET'),
  // 月度考核维护-分配品牌-提交品牌
  submitBrand = data => fetch('/platform/supplierMonthExamineManage/addOrUpdateSupplierExamineConfigBrand', data, 'POST'),

  // 大屏维护-获取配置
  queryDataConfig = data => fetch('/platform/dataReportManage/queryDataConfig', data, 'GET'),
  // 大屏维护-新增/修改
  addOrUpdateDataConfig = data => fetch('/platform/dataReportManage/addOrUpdateDataConfig', data, 'POST'),

  //电子围栏管理-分页查询
  getPage = data => fetch('/platform/area/fenceCollection/getPage', data, 'GET'),
  //电子围栏管理-新增
  addElectronicFence = data => fetch('/platform/area/fenceCollection/add', data, 'POST'),
  //电子围栏管理-详情
  getPageId = (data) => fetch(`/platform/area/fenceCollection/queryRegion/${data.id}`, {}, 'GET'),
  //电子围栏管理-删除所选电子围栏信息
  electronicFenceDelete = (data) => fetch('/platform/area/fenceCollection/delete', data, 'POST'),
  //电子围栏管理-停用、启用所选电子围栏信息
  updateStatus = (data) => fetch('/platform/area/fenceCollection/updateStatus', data, 'POST');


